// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2g5D-","left":"styles_left__zDtrN"};